export default __webpack_public_path__ + "static/media/qr_white.295f86a9.svg";